import Vue from 'vue'
import '../components/_loadComponents' // load all components
import { CORELoadCommonComponent } from '@shared/nuxt/plugins/loadCommonComponent'
CORELoadCommonComponent(Vue) // load
